import React from 'react';

import {Group, Item} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';

import {MAX_RECORD_SIZE, UPLOAD_FILE_VALID_EXTENSIONS} from '../constants';

import {dropZoneViewServiceIcon} from './drop-zone-view.module.styl';

type Props = {
    addedFile: File | null,
};

const getUploadFileExtensionsLine = (): string => (
    UPLOAD_FILE_VALID_EXTENSIONS.map(item => item.slice(1).toUpperCase()).join(', ')
);

export const DropZoneView = ({addedFile}: Props) => {
    if (addedFile) {
        return (
            <div style={{width: 900}}>
                <Group direction="v" gap="s">
                    <Icon className={dropZoneViewServiceIcon} type={Icons.CHECK_CIRCLE}/>
                    <Item>Completed</Item>
                </Group>
            </div>
        );
    }

    return (
        <div style={{width: 900}}>
            <Group direction="v" gap="xxs">
                <Icon className={dropZoneViewServiceIcon} type={Icons.UPLOAD}/>
                <span>Drag & drop a file to upload or <a>browse</a></span>
                <span className="font-size font-size_footer">
                    {
                        `Max. users count: ${MAX_RECORD_SIZE} records.
                        Accepted formats: ${getUploadFileExtensionsLine()}`
                    }
                </span>
            </Group>
        </div>
    );
};
